import { render, staticRenderFns } from "./manage-studio.vue?vue&type=template&id=c2e76efe&"
import script from "./manage-studio.vue?vue&type=script&lang=js&"
export * from "./manage-studio.vue?vue&type=script&lang=js&"
import style0 from "./manage-studio.vue?vue&type=style&index=0&id=c2e76efe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports